/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../../shared/GlobalStyles';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import {
  setSaveDashboardModal,
  createDashboard,
} from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import Button from '../../../../../shared/_TBComponents/Button';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';
import {
  createLMTemplate,
  setSaveLMDashModal,
} from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import {
  createFPTemplate,
  setSaveFPDashModal,
} from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import {
  createVTTemplate,
  setSaveVTDashModal,
} from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import {
  createVBTTemplate,
  setGraphThresholds,
  setSaveVBTDashModal,
  setTableThreshold,
} from '../../../../vbt-dashboard/ducks/vbtDashboardActions';
import SharedTemplateModalContainer from './SharedTemplateModalContainer';
import SharedInput from '../../../../../shared/_TBComponents/Input';

const BlockText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 500;
`;

const BlockSubtext = styled('div')`
  color: #9E9E9E;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  white-space: break-spaces;
`;

const ButtonContainer = styled('div')`
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const ContentContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-height: ${(props) => props.customHeight};
  padding-left: 40px;
  padding-right: 40px;
  transition: max-height 0.5s linear;
  width: 100%;
`;

const Divider = styled('span')`
  align-content: center;
  color: #9E9E9E;
  line-height: 36px;
  margin: 0px 5px;
`;

const ErrorBox = styled('div')`
  display: flex;
  flex-direction: column;
`;

const HeaderIconContainer = styled('div')`
  align-items: center;
  border: 1px solid black;
  border-radius: 50%;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 52px;
`;

const MappedError = styled('div')`
  color: #c0392b;
  font-family: 'Nunito Sans';
  font-size: 14px;
`;

const Max = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;
  width: 45%;
`;

const Min = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;
  width: 45%;
`;

const ModalContainer = styled('div')`
  border-radius: 12px;
  left: 50%;
  max-height: calc(100vh - 20px);
  min-height: 270px;
  min-width: 430px;
  overflow: auto;
  position: absolute;
  right: 50%;
  top: 50%;
  transition: all 0.3s linear, opacity 0.3s ease-out;
  opacity: ${(props) => (props.isActive ? '1' : '0')};
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isActive ? 'translate(-50%,-50%)' : 'translate(-50%, 300%)')};
  user-select: none;
  width: 50vw;
  z-index: 1003;

  @media only screen and (max-width: 768px) {
    width: 90vw;
  }
`;

const ModalHeader = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
`;

const ModalHeaderText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
`;

const PortalContainer = styled('div')`
  background: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: ${BoxShadow};
  overflow: auto;
  width: 100%;
`;

const RelativePortalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const RemoveDiv = styled('div')`
  background: white;
  color: ${(props) => (props.isDarkMode ? 'white' : '#444444')};
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  width: 100%;
  z-index: 1001;

  .remove-div-icon {
    cursor: pointer;
  }
`;

const Slide = styled('div')`
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Slide2Block2 = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const SlideIndicator = styled('div')`
  background: ${(props) => (props.isActive ? 'grey' : 'none')};
  border: 1px solid grey;
  border-radius: 50%;
  height: 7px;
  margin-left: 5px;
  margin-right: 5px;
  transition: background-color 0.5s ease;
  width: 7px;
`;

const SlideIndicators = styled('div')`
  align-items: center;
  background: white;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 100%;
`;

const Slides = styled('div')`
  height: 100%;
  transition: transform 0.5s ease;
  transform: ${(props) => `translateX(-${props.activeSlide * 100}%)`};
  white-space: nowrap;
`;

const SlidesContainer = styled('div')`
  max-height: ${(props) => props.customHeight};
  overflow: hidden;
  transition: max-height 1s linear;
  width: 100%;
`;

const ThresholdContainer = styled('div')`
  align-items: center;
  display: flex;
  margin-bottom: 5px;
`;

const ThresholdsContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.direction)};
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px 10px 25px;
`;

const selectBoxOne = [
  { name: 'All groups', id: 1 },
  { name: 'Select groups', id: 2 },
  { name: 'Private', id: 3 },
];

const SharedTemplateSaveModal = ({ dashboard, legacyName }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  let exercises = [];
  let groups = [];
  let handleCreateTemplate = () => {};
  let isModalShowing = false;
  let keyPerformanceMetrics = [];
  let loadMonitoringFormValues = {};
  let maxType = '';
  let metricFiltersPerformance = [];
  let setSaveModalShowing = () => {};
  let vbtGraphThresholds = [];
  let vbtTableThreshold = {};

  const dispatch = useDispatch();

  if (dashboard === 'Force Plate') {
    groups = useSelector((state) => state.forcePlateDashboard.data.groups);
    handleCreateTemplate = createFPTemplate;
    isModalShowing = useSelector(
      (state) => state.forcePlateDashboard.ui.saveModalShowing,
    );
    keyPerformanceMetrics = useSelector(
      (state) => state.forcePlateDashboard.data.keyPerformanceMetrics,
    );
    metricFiltersPerformance = useSelector(
      (state) => state.forcePlateDashboard.data.metricFiltersPerformance,
    );
    setSaveModalShowing = setSaveFPDashModal;
  }

  if (dashboard === 'KPI Tracker') {
    exercises = useSelector(
      (state) => state.sportCoachDashboard.data.exercises,
    );
    groups = useSelector((state) => state.sportCoachDashboard.data.groups);
    handleCreateTemplate = createDashboard;
    isModalShowing = useSelector(
      (state) => state.sportCoachDashboard.ui.saveDashboardModalShowing,
    );
    maxType = useSelector((state) => state.sportCoachDashboard.data.maxType);
    setSaveModalShowing = setSaveDashboardModal;
  }

  if (dashboard === 'Load Monitoring') {
    groups = useSelector(
      (state) => state.loadMonitoringDashboard.data.reportableGroups,
    );
    handleCreateTemplate = createLMTemplate;
    isModalShowing = useSelector(
      (state) => state.loadMonitoringDashboard.ui.saveModalShowing,
    );
    loadMonitoringFormValues = useSelector(
      (state) => state.loadMonitoringDashboard.data.loadMonitoringFormValues,
    );
    setSaveModalShowing = setSaveLMDashModal;
  }

  if (dashboard === 'VBT') {
    exercises = useSelector((state) => state.vbtDashboard.data.exercises);
    groups = useSelector((state) => state.vbtDashboard.data.groups);
    handleCreateTemplate = createVBTTemplate;
    isModalShowing = useSelector((state) => state.vbtDashboard.ui.saveModalShowing);
    setSaveModalShowing = setSaveVBTDashModal;
    vbtGraphThresholds = useSelector((state) => state.vbtDashboard.data.graphThresholds);
    vbtTableThreshold = useSelector((state) => state.vbtDashboard.data.tableThreshold);
  }

  if (dashboard === 'Volume Tracker') {
    exercises = useSelector(
      (state) => state.volumeTrackerDashboard.data.exercises,
    );
    groups = useSelector(
      (state) => state.volumeTrackerDashboard.data.groups,
    );
    handleCreateTemplate = createVTTemplate;
    isModalShowing = useSelector(
      (state) => state.volumeTrackerDashboard.ui.saveModalShowing,
    );
    setSaveModalShowing = setSaveVTDashModal;
  }

  const [activeSlide, setActiveSlide] = useState(0);
  const [dashDescription, setDashDescription] = useState('');
  const [dashTitle, setDashTitle] = useState('');
  const [errors, setErrors] = useState({
    errorsExist: true,
    errors: [
      {
        error: 'name error',
        msg: 'You must add a dashboard title',
        isShowing: false,
      },
      {
        error: 'incomplete item error',
        msg: 'Some evaluation items are incomplete',
        isShowing: false,
      },
      {
        error: 'group error',
        msg: 'You must select at least one group',
        isShowing: false,
      },
      {
        error: 'API error',
        msg:
          'There was an issue saving the dashboard, please check the form and try again.',
        isShowing: false,
      },
      {
        error: 'threshold error',
        msg: 'One or more thresholds are invalid, please check and try again',
        isShowing: false,
      },
      {
        error: 'duplicate threshold error',
        msg: 'You cannot have duplicate performance overview thresholds',
        isShowing: false,
      },
    ],
  });
  const [errorsMulti, setErrorsMulti] = useState(
    dashboard === 'VBT' && vbtGraphThresholds?.length
      ? vbtGraphThresholds.map(() => ({ min: false, max: false }))
      : dashboard === 'VBT' ? [{ min: false, max: false }] : undefined,
  );
  const [errorsThreshold, setErrorsThreshold] = useState(
    dashboard === 'VBT' ? { min: false, max: false } : undefined,
  );
  const [groupType, setGroupType] = useState({ name: 'All groups', id: 1 });
  const [gThresholds, setGThresholds] = useState(
    dashboard === 'VBT'
      ? (vbtGraphThresholds?.length
        ? vbtGraphThresholds
        : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }])
      : undefined,
  );
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [tThreshold, setTThreshold] = useState(
    dashboard === 'VBT'
      ? { min: vbtTableThreshold.min ?? '', max: vbtTableThreshold.max ?? '' }
      : undefined,
  );

  const exerIds = exercises.length > 0 && exercises.map((item) => item.id);

  const handleClose = () => {
    dispatch(setSaveModalShowing(false));
    setActiveSlide(0);
    setDashTitle('');
    setDashDescription('');
    setGroupType({ name: 'All groups', id: 1 });
    setSelectedGroups([]);
    if (dashboard === 'VBT') {
      setGThresholds(vbtGraphThresholds?.length ? vbtGraphThresholds : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }]);
      setTThreshold({
        min: vbtTableThreshold.min ?? '',
        max: vbtTableThreshold.max ?? '',
      });
      setErrorsThreshold({ min: false, max: false });
      setErrorsMulti(
        vbtGraphThresholds?.length
          ? vbtGraphThresholds.map(() => ({ min: false, max: false }))
          : [{ min: false, max: false }],
      );
    }
  };

  const handleGraphThresholdChange = (index, field, value) => {
    if (dashboard !== 'VBT') return;
    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setGThresholds((prevThresholds) => {
      const updatedThresholds = [...prevThresholds];
      const prev = updatedThresholds[index] || { min: '', max: '' };
      const updated = { ...prev, [field]: formattedValue };
      updatedThresholds[index] = updated;
      setErrorsMulti((prevErrors) => {
        const updatedErrors = [...prevErrors];
        const newMin = updated.min !== undefined ? updated.min : '';
        const newMax = updated.max !== undefined ? updated.max : '';
        const hasValue = newMin !== '' || newMax !== '';
        updatedErrors[index] = {
          min: hasValue && (newMin === '' || Number(newMin) <= 0),
          max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
        };
        return updatedErrors;
      });
      return updatedThresholds;
    });
  };

  const handleTableThresholdChange = (field, value) => {
    if (dashboard !== 'VBT') return;
    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setTThreshold((prevThreshold) => {
      const updated = { ...prevThreshold, [field]: formattedValue };
      const newMin = updated.min !== undefined ? updated.min : '';
      const newMax = updated.max !== undefined ? updated.max : '';
      const hasValue = newMin !== '' || newMax !== '';
      setErrorsThreshold({
        min: hasValue && (newMin === '' || Number(newMin) <= 0),
        max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
      });
      return updated;
    });
  };

  const isValidThreshold = (t) => {
    const min = Number(t.min);
    const max = Number(t.max);
    return (
      t.min !== '' && t.max !== '' && !Number.isNaN(min) && !Number.isNaN(max)
    );
  };

  const mapToNumeric = (t) => ({ ...t, min: Number(t.min), max: Number(t.max) });

  const preventEAndMinus = (e) => {
    if (e.key === 'e' || e.key === 'E' || e.key === '-') {
      e.preventDefault();
    }
  };

  const thresholdValidator = () => {
    // Check for individual threshold errors
    const hasTableThresholdErrors = errorsThreshold?.min || errorsThreshold?.max;
    const hasGraphThresholdErrors = gThresholds?.some((t, i) => {
      const err = errorsMulti[i] || {};
      return (err.min || err.max);
    });

    if (hasTableThresholdErrors || hasGraphThresholdErrors) {
      return 'thresholdError';
    }

    // Check for duplicate graph thresholds
    const validGraphThresholds = gThresholds?.filter(isValidThreshold) || [];

    // Normalize thresholds by converting to numbers and creating normalized strings
    const normalizedThresholds = validGraphThresholds.map((t) => {
      const min = Number(t.min);
      const max = Number(t.max);
      return {
        min,
        max,
        normalizedString: `${min}-${max}`,
      };
    });

    // Check for duplicates using normalized values
    const thresholdStrings = normalizedThresholds.map((t) => t.normalizedString);
    const uniqueThresholdStrings = [...new Set(thresholdStrings)];
    const hasDuplicateThresholds = thresholdStrings.length !== uniqueThresholdStrings.length;

    if (hasDuplicateThresholds) {
      return 'duplicatesError';
    }

    return null;
  };

  const handleSubmit = () => {
    if (dashTitle.length) {
      if (activeSlide === 0) {
        setActiveSlide(1);
      } else if (dashboard === 'VBT' && activeSlide === 1) {
        const thresholdError = thresholdValidator();
        if (thresholdError) {
          const newErrors = { ...errors };

          if (thresholdError === 'duplicatesError') {
            newErrors.errors[5].isShowing = true;
            newErrors.errors[4].isShowing = false;
          } else if (thresholdError === 'thresholdError') {
            newErrors.errors[4].isShowing = true;
            newErrors.errors[5].isShowing = false;
          }
          setErrors(newErrors);
        } else {
          const newErrors = { ...errors };
          newErrors.errors[4].isShowing = false;
          newErrors.errors[5].isShowing = false;
          setErrors(newErrors);
          setActiveSlide(2);
        }
      } else {
        let groupArray = [];
        if (groupType.id === 1) {
          groupArray = groups.map((obj) => obj.id);
        } else if (groupType.id === 2) {
          if (selectedGroups.length > 0) {
            groupArray = selectedGroups.map((obj) => obj.id);
            const newErrors = { ...errors };
            newErrors.errors[2].isShowing = false;
            setErrors(newErrors);
          } else {
            const newErrors = { ...errors };
            newErrors.errors[2].isShowing = true;
            setErrors(newErrors);
            return;
          }
        }
        let submissionObj = {
          title: dashTitle,
          description: dashDescription,
        };
        if (dashboard === 'Load Monitoring') {
          const {
            questionnaire,
            arrayOfQuestions,
            showRangeAverages,
            showTotal,
          } = loadMonitoringFormValues;

          submissionObj = {
            ...submissionObj,
            groupIds: groupArray,
            isQuestionnaire: !!questionnaire,
            itemIds: questionnaire
              ? [questionnaire.id]
              : arrayOfQuestions.map((question) => question.id),
            showAverages: showRangeAverages,
            showTotals: showTotal,
          };
        }
        if (dashboard === 'Force Plate') {
          submissionObj = {
            ...submissionObj,
            chartForcePlateMetrics: metricFiltersPerformance,
            kpiForcePlateMetrics: keyPerformanceMetrics.map((metric) => metric.replace(/\s/g, '')),
            groupIds: groupArray,
          };
        }
        if (dashboard === 'KPI Tracker') {
          submissionObj = {
            ...submissionObj,
            maxType,
            exercises: exerIds,
            groups: groupArray,
          };
        }
        if (dashboard === 'Volume Tracker') {
          submissionObj = {
            ...submissionObj,
            exerciseIds: exerIds,
            groupIds: groupArray,
          };
        }
        if (dashboard === 'VBT') {
          submissionObj = {
            ...submissionObj,
            exerciseIds: exerIds,
            groupIds: groupArray,
            thresholds: {
              graphThresholds: gThresholds.filter(isValidThreshold).map(mapToNumeric),
              tableThreshold: isValidThreshold(tThreshold) ? mapToNumeric(tThreshold) : {},
            },
          };
        }
        if (dashboard === 'VBT') {
          batch(() => {
            dispatch(setGraphThresholds(
              gThresholds.filter(isValidThreshold).map(mapToNumeric),
            ));
            dispatch(setTableThreshold(
              isValidThreshold(tThreshold) ? mapToNumeric(tThreshold) : {},
            ));
            dispatch(handleCreateTemplate(currentUser.accountCode, submissionObj));
          });
        } else {
          dispatch(handleCreateTemplate(currentUser.accountCode, submissionObj));
        }
        // Amplitude tracking
        dashboardTracker(
          `${legacyName} Dashboard`,
          'Save Dashboard',
          'Dashboard saved',
        );
        handleClose();
      }
    } else {
      const newErrors = { ...errors };
      newErrors.errors[0].isShowing = true;
      setErrors(newErrors);
    }
  };

  useEffect(() => {
    if (isModalShowing === false) {
      setErrors({
        errorsExist: true,
        errors: [
          {
            error: 'name error',
            msg: 'You must add a dashboard title',
            isShowing: false,
          },
          {
            error: 'incomplete item error',
            msg: 'Some evaluation items are incomplete',
            isShowing: false,
          },
          {
            error: 'group error',
            msg: 'You must select at least one group',
            isShowing: false,
          },
          {
            error: 'API error',
            msg:
              'There was an issue saving the dashboard, please check the form and try again.',
            isShowing: false,
          },
          {
            error: 'threshold error',
            msg: 'One or more thresholds are invalid, please check and try again',
            isShowing: false,
          },
          {
            error: 'duplicate threshold error',
            msg: 'You cannot have duplicate performance overview thresholds',
            isShowing: false,
          },
        ],
      });
      setActiveSlide(0);
      setDashTitle('');
      setDashDescription('');
      setGroupType({ name: 'All groups', id: 1 });
      setSelectedGroups([]);
      if (dashboard === 'VBT') {
        setGThresholds(vbtGraphThresholds?.length ? vbtGraphThresholds : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }]);
        setTThreshold({
          min: vbtTableThreshold.min ?? '',
          max: vbtTableThreshold.max ?? '',
        });
        setErrorsThreshold({ min: false, max: false });
        setErrorsMulti(
          vbtGraphThresholds?.length
            ? vbtGraphThresholds.map(() => ({ min: false, max: false }))
            : [{ min: false, max: false }],
        );
      }
    }
  }, [isModalShowing]);

  return (
    <>
      <ModalContainer
        isActive={isModalShowing}
        customWidth={dashboard === 'VBT' ? (activeSlide === 2 ? '550px' : '1000px') : (activeSlide === 1 ? '550px' : '1000px')}
        customHeight={dashboard === 'VBT' ? (activeSlide === 2 && groupType.id !== 2 ? '200px' : '500px') : (activeSlide === 1 && groupType.id !== 2 ? '200px' : '500px')}
      >
        <RelativePortalContainer>
          <ButtonContainer>
            <div />
            <PortalContainer>
              <RemoveDiv>
                {activeSlide !== 0 ? (
                  <div
                    className='remove-div-icon'
                    onClick={() => {
                      if (dashboard === 'VBT') {
                        if (activeSlide === 1) {
                          const newErrors = { ...errors };
                          newErrors.errors[4].isShowing = false;
                          newErrors.errors[5].isShowing = false;
                          newErrors.errorsExist = false;
                          setErrors(newErrors);
                          setActiveSlide(0);
                        } else {
                          setActiveSlide(1);
                        }
                      } else {
                        setActiveSlide(0);
                      }
                    }}
                  >
                    <IcomoonReact
                      iconSet={iconSet}
                      size={18}
                      icon='left-arrow'
                      color='#444444'
                    />
                  </div>
                ) : null}
                <ModalHeader>
                  <HeaderIconContainer>
                    <IcomoonReact iconSet={iconSet} size={20} icon='save' />
                  </HeaderIconContainer>
                  <ModalHeaderText>Save Dashboard</ModalHeaderText>
                  <ErrorBox>
                    {errors.errors[0].isShowing ? (
                      <MappedError>{errors.errors[0].msg}</MappedError>
                    ) : null}
                    {errors.errors[1].isShowing ? (
                      <MappedError>{errors.errors[1].msg}</MappedError>
                    ) : null}
                    {errors.errors[2].isShowing ? (
                      <MappedError>{errors.errors[2].msg}</MappedError>
                    ) : null}
                    {errors.errors[3].isShowing ? (
                      <MappedError>{errors.errors[3].msg}</MappedError>
                    ) : null}
                    {errors.errors[4]?.isShowing ? (
                      <MappedError>{errors.errors[4].msg}</MappedError>
                    ) : null}
                    {errors.errors[5]?.isShowing ? (
                      <MappedError>{errors.errors[5].msg}</MappedError>
                    ) : null}
                  </ErrorBox>
                </ModalHeader>
                <div className='remove-div-icon' onClick={handleClose}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={15}
                    icon='remove'
                    color='black'
                  />
                </div>
              </RemoveDiv>
              <ContentContainer
                customHeight={dashboard === 'VBT' ? (activeSlide === 2 && groupType.id !== 2 ? '200px' : '500px') : (activeSlide === 1 && groupType.id !== 2 ? '200px' : '500px')}
              >
                <SlidesContainer customHeight='auto'>
                  <Slides activeSlide={activeSlide}>
                    <Slide>
                      {/* Title/Description Step */}
                      <SharedInput
                        charLimit={50}
                        fontSize='unset'
                        fontWeight={400}
                        height='40px'
                        label='Title'
                        name='dashTitle'
                        onBlur={() => {
                          if (!dashTitle.length) {
                            const newErrors = { ...errors };
                            newErrors.errors[0].isShowing = true;
                            setErrors(newErrors);
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value.length <= 50) {
                            if (
                              errors.errors[0].isShowing
                              && e.target.value.length
                            ) {
                              const newErrors = { ...errors };
                              newErrors.errors[0].isShowing = false;
                              setErrors(newErrors);
                            }
                            setDashTitle(e.target.value);
                          }
                        }}
                        placeholder='Title'
                        placeHolderColor='#444444'
                        styledPropsLabel={{
                          marginBottom: 'unset',
                          fontSize: '16px',
                        }}
                        styledPropsWrapper={{
                          display: 'flex',
                          flexDirection: 'column',
                          margin: '10px 0px',
                        }}
                        textColor='#444444'
                        value={dashTitle}
                      />
                      <SharedInput
                        charLimit={500}
                        fontSize='unset'
                        fontWeight={400}
                        height='75px'
                        isTextArea
                        label='Description'
                        name='dashDescription'
                        onChange={(e) => {
                          if (e.target.value.length <= 500) {
                            setDashDescription(e.target.value);
                          }
                        }}
                        placeholder='Description (optional)'
                        placeHolderColor='#444444'
                        styledPropsLabel={{
                          marginBottom: 'unset',
                          fontSize: '16px',
                        }}
                        styledPropsWrapper={{
                          display: 'flex',
                          flexDirection: 'column',
                          margin: '10px 0px',
                        }}
                        textColor='#444444'
                        value={dashDescription}
                      />
                    </Slide>
                    {dashboard === 'VBT' && (
                      <Slide>
                        {/* Thresholds Step */}
                        <BlockText style={{ fontWeight: 700 }}>
                          Performance Overview Thresholds (optional)
                        </BlockText>
                        <BlockSubtext>
                          Visualize targets by adding up to 3 minimum and maximum thresholds below
                        </BlockSubtext>
                        <ThresholdsContainer direction='column'>
                          <ThresholdContainer>
                            <Min
                              id='min-1'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(0, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[0]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[0]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-1'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(0, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[0]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[0]?.max || ''}
                            />
                          </ThresholdContainer>
                          <ThresholdContainer>
                            <Min
                              id='min-2'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(1, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[1]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[1]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-2'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(1, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[1]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[1]?.max || ''}
                            />
                          </ThresholdContainer>
                          <ThresholdContainer>
                            <Min
                              id='min-3'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(2, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[2]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[2]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-3'
                              min={0}
                              onChange={(e) => handleGraphThresholdChange(2, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[2]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[2]?.max || ''}
                            />
                          </ThresholdContainer>
                        </ThresholdsContainer>
                        <BlockText style={{ fontWeight: 700 }}>
                          Group Analysis Threshold (optional)
                        </BlockText>
                        <BlockSubtext>
                          Visualize targets by adding minimum and maximum thresholds below
                        </BlockSubtext>
                        <ThresholdsContainer direction='row'>
                          <Min
                            id='min-4'
                            min={0}
                            onChange={(e) => handleTableThresholdChange('min', e.target.value)}
                            onKeyDown={preventEAndMinus}
                            placeholder='0.4 m/s'
                            step='0.1'
                            style={{
                              border: errorsThreshold.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                            }}
                            type='number'
                            value={tThreshold.min}
                          />
                          <Divider>-</Divider>
                          <Max
                            id='max-4'
                            min={0}
                            onChange={(e) => handleTableThresholdChange('max', e.target.value)}
                            onKeyDown={preventEAndMinus}
                            placeholder='0.6 m/s'
                            step='0.1'
                            style={{
                              border: errorsThreshold.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                            }}
                            type='number'
                            value={tThreshold.max}
                          />
                        </ThresholdsContainer>
                      </Slide>
                    )}
                    <Slide>
                      {/* Group Selection Step */}
                      <BlockText>Group Access</BlockText>
                      <Slide2Block2>
                        <Select
                          className='item-select'
                          value={groupType}
                          options={selectBoxOne}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          onChange={(option) => {
                            setGroupType(option);
                          }}
                        />
                      </Slide2Block2>
                      {groupType.id === 2 ? (
                        <>
                          <BlockText>Select Groups</BlockText>
                          <Slide2Block2>
                            <Select
                              className='item-select'
                              options={groups}
                              isMulti
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              onChange={(selectGroups) => {
                                if (
                                  errors.errors[2].isShowing
                                  && selectGroups.length
                                ) {
                                  const newErrors = { ...errors };
                                  newErrors.errors[2].isShowing = false;
                                  setErrors(newErrors);
                                }
                                setSelectedGroups(selectGroups);
                              }}
                            />
                          </Slide2Block2>
                        </>
                      ) : null}
                    </Slide>
                  </Slides>
                </SlidesContainer>
              </ContentContainer>
            </PortalContainer>
            <SlideIndicators>
              <SlideIndicator isActive={activeSlide === 0} />
              {dashboard === 'VBT' ? <SlideIndicator isActive={activeSlide === 1} /> : null}
              <SlideIndicator isActive={dashboard === 'VBT' ? activeSlide === 2 : activeSlide === 1} />
            </SlideIndicators>
            <Button
              bgColor='#424242'
              bottom
              fontSize='14px'
              fullWidth
              large
              name={dashboard === 'VBT' ? (activeSlide !== 2 ? 'Next' : 'Submit') : (activeSlide === 0 ? 'Next' : 'Submit')}
              noBorder
              onClick={handleSubmit}
              square
              styledWrapperProps={{
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
              }}
              txtColor='#FFFFFF'
              upperCase
            />
          </ButtonContainer>
        </RelativePortalContainer>
      </ModalContainer>
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
        setModalShowing={setSaveModalShowing}
      />
    </>
  );
};

SharedTemplateSaveModal.defaultProps = {
  dashboard: 'Load Monitoring',
  legacyName: 'Load Monitoring',
};

SharedTemplateSaveModal.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
};

export default SharedTemplateSaveModal;
